import { User, Bell, Shield, Key, Globe, ChevronRight } from "lucide-react";
import { PageHeader } from "../components/ui";

const SECTIONS = [
  { title: "Profile", icon: User, description: "Name, email, and account details." },
  { title: "Notifications", icon: Bell, description: "Scan completion and finding alerts." },
  { title: "Security", icon: Shield, description: "API keys, 2FA, and active sessions." },
  { title: "API access", icon: Key, description: "Tokens for CI/CD and automation." },
  { title: "General", icon: Globe, description: "Region, timezone, and display preferences." },
];

export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Settings"
        description="Manage your account and how Petir behaves."
      />

      <div className="space-y-2">
        {SECTIONS.map(({ title, icon: Icon, description }) => (
          <button
            key={title}
            className="card group flex w-full items-center gap-4 p-4 text-left transition-colors hover:border-line-strong"
          >
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-ink-800 text-mist-400 transition-colors group-hover:text-volt-400">
              <Icon className="h-5 w-5" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-medium text-mist-100">{title}</p>
              <p className="text-sm text-mist-400">{description}</p>
            </div>
            <ChevronRight className="h-4 w-4 shrink-0 text-mist-600 transition-transform group-hover:translate-x-0.5 group-hover:text-mist-400" />
          </button>
        ))}
      </div>

      <p className="pt-4 text-xs text-mist-600">Petir v0.1.0 — AI pentest platform</p>
    </div>
  );
}
